<template>
	<div>
		<van-swipe class="jump-swipe startup" @change="onChange" ref='swipe'>
            <van-swipe-item v-for="simg in listIndexArticle" >
                <a :href="simg.activityUrl"><img v-lazy="simg.activityImg" ></a>
            </van-swipe-item>
        </van-swipe>
        <span class="skip_box" @click="skip" v-if="listIndexArticle.length > 0">跳过</span>
	</div>
</template>
<script>
	import { Swipe, SwipeItem, Button  } from "vant";
	export default {
	  	name: 'startup',
	  	components: {
		    [Swipe.name]: Swipe,
		    [SwipeItem.name]: SwipeItem,
		    [Button.name]: Button,
	  	},
		data() {
			return {
				listIndexArticle: [],
				second: '',
				time_count: '',
				timer: null,
				swiping: true,
				swipeImgs: [
			        "http://image.demo.b2b2c.shopxx.net/6.0/90dec122-d73f-494f-a9c8-4bfa4d0b1baf.jpg"
			    ],
			    currentIndex:0,
			}
		},
		created() {
		   let guide = localStorage.getItem('guide');
            if (guide == 1) {
				// this.$router.replace("/home") ;
            }
		},
		methods: {
			// guide() {
			// 	localStorage.setItem('guide', true);
			// 	location.href = '#/home'
			// },
			skip() {
				this.second = 0;
				this.$router.replace("/home") ;
			    // localStorage.setItem('guide', true);
			},
			onChange(index) {
				if(this.currentIndex==0 && index==2){
					this.$refs.swipe.swipeTo(0);
					return;
				}
				if(this.currentIndex==2 && index==0){
					this.$router.replace("/home") ;
			    	// localStorage.setItem('guide', true);
				}
				this.currentIndex=index;
		    },
		    getCode(){
		        let time_count = 3;
		        var that = this;
		        if (!that.timer) {
		            that.second = time_count;
		            that.timer = setInterval(() => {
			            if (that.second > 0 && that.second <= time_count) {
			             	that.second--;
			            } else {
			            	let isStartUp=localStorage.getItem('isStartUp')
			            	if(isStartUp==null){
								// location.href = '#/home';
								that.$router.replace("/home") ;
				            	// localStorage.setItem('guide', true);
				             	clearInterval(that.timer);
				             	that.timer = null;
			             	}else if(localStorage.getItem('guide')){
								that.$router.replace("/home") ;
			             		clearInterval(that.timer);
			             	}
			            }
		            }, 1000)
		        }
		    }  
		},
		mounted() {
            let that = this;
            // let guide = localStorage.getItem('guide');
            // if (guide == 1) {
            //      location.href = '#/home'
            // } else {
            localStorage.setItem('guide', 1);
            localStorage.setItem("showAdArticle", 0);
            // 启动页
			this.$api.get(that.jumuc.getIndexArticle, null,
				successRes => {
					if (successRes.success) {
						that.listIndexArticle = successRes.data.listIndexArticle;
						if(that.listIndexArticle.length == 0){
							that.$router.replace("/home") ;
						}
					}
				})
			this.getCode()
            // }
        }
	}
</script>
<style lang="less" scoped>
	.startup {

        padding: 0px!important;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 1;
		width: 100%!important;
		height: 100%!important;
		img {
			height: 100%;
		}
	}
    .startup img{
        width: 100%;
        height: 100%;
    }
	.time_box, .skip_box {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		position: fixed;
		top: 10px;
		right: 10px;
		background: #333;
		color: rgb(255, 255, 255, 0.5);
		z-index: 10000;
		text-align: center;
		line-height: 40px;
		font-size: 12px;
	}
	.skip_box {
		// top: 60px;
	}
	.experBtn {
		position: fixed;
		z-index: 1000;
		color: #fff;
		border-radius: 4px;
		background: #3c6eeb;
		bottom: 2rem;
		left: 50%;
		transform: translate(-50%);
	}
</style>